import { render } from "preact";
import {
  ErrorBoundary,
  lazy,
  LocationProvider,
  Route,
  Router,
} from "preact-iso";
import App from "./App";
import "./index.css";

const Posts = lazy(() => import("./Posts"));
const About = lazy(() => import("./About"));
const Sky = lazy(() => import("./Sky"));
const Contact = lazy(() => import("./Contact"));
const Underground = lazy(() => import("./Underground"));

render(
  <LocationProvider>
    <ErrorBoundary>
      <Router>
        <Route path="/" component={App} />
        <Route path="/posts" component={Posts} />
        <Route path="/about" component={About} />
        <Route path="/sky" component={Sky} />
        <Route path="/contact" component={Contact} />
        <Route path="/underground" component={Underground} />
      </Router>
    </ErrorBoundary>
  </LocationProvider>,
  document.getElementById("root") as HTMLElement
);
